/* eslint-disable react/prefer-stateless-function */
import React, { Fragment, PureComponent } from 'react'

// Kevin R (2020-02-04)
// Note technically this could be a function but for some reason
// the matrix skinning system doent accept a fuction that has been
// wrapped with the forwardRefs method causing a bunch of warnings
// for components that we're overriding with Empty.
export default class Empty extends PureComponent {
  render() {
    return <Fragment />
  }
}
